export default "__VITE_ASSET__B2wjwrb9__"